import {Config, ErrorFlow, BrickContext} from 'olympe';
import UserDefaults from '../../../models/cloudobjects/UserDefaults';
import {checkLabelValueObject, isLabelValue, isLabelValueEmpty} from '../../../utils/checkObjects';
import {Material} from '../../../models/Material';
import {addNBusinessDays} from '../../../utils/date';
import {POSendingOptions} from '../../../models/POSendingOptions';
import {NBSValidation} from '../../../models/NBSValidation';
import {SBValidation} from '../../../models/SBValidation';
import {Account} from '../../../models/financial_infos/Account';
import {FinancialInfo} from '../../../models/FinancialInfo';
import {AttachmentsInfo} from '../../../models/AttachmentsInfo';
import {OneTimeVendor} from '../../../models/OneTimeVendor';
import {HeaderDetails} from '../../../models/HeaderDetails';
import {WaysOfBuying} from '../../../models/WaysOfBuying';
import {
    accountTypeOptions,
    complianceIndicatorOptions,
    ezprOrange,
    getUniquePrId,
    wayOfBuyingOptions,
} from '../../_helpers';
import {extractValuesFromWayOfBuyingOptions} from '../../../utils/wayOfBuying';
import {createPRJson} from '../../../utils/createPRJson';
import {PurchaseRequest} from '../../../models/PurchaseRequest';
import {
    getAddressFromPlantCodeLambda,
    getBaseUnitLambda, getL3CategoryLambda,
} from '../../../utils/functionSignatures';
import {EZPRTheme} from '../../_theme';
import {MasterDataDropdown} from '../../pr_editor/utils/MasterDataDropdown.jsx';
import {ControlledEZPRSelect} from '../../pr_editor/utils/ControlledEZPRSelect.jsx';
import {SelectProviderSupplierTable} from './SelectProviderSupplierTable.jsx';
import PropTypes from 'prop-types';
import React, {useEffect, useState} from 'react';
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    InputAdornment,
    ThemeProvider,
    CircularProgress, Select, FormControl,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LoadingButton from '@mui/lab/LoadingButton';
import {ErrorPopup} from '../../pr_editor/dialogs/ErrorPopup.jsx';
import {DefineSupplierContent} from '../../pr_editor/dialogs/search_supplier_components/DefineSupplierContent.jsx';
import {createPRStore} from '../../pr_editor/utils/createStore';
import {requestStores} from '../../ListOfPREditors.brick.jsx';
import {Attachment} from '../../../models/attachments_info/Attachment';
import {
    getStringValueForSourceFromApiKey,
    NON_PSL_JUSTIFICATIONS,
    SOURCES,
    TRANSPORT_OPTIONS_ENUM,
} from '../../../utils/constants.js';
import MenuItem from '@mui/material/MenuItem';
import {fetchAndProcessIncoterms} from '../../../utils/incotermsHelpers';
import {L3CategoryDropdown} from './L3CategoryDropdown.jsx';
import {ItemCodeDescriptionDropdown} from './ItemCodeDescriptionDropdown.jsx';
import {GenericPopup} from '../GenericPopup.jsx';
import {convertSourceToLabelValue} from '../../../utils/sourceMappings';
import {getVendorCodes} from "../../../utils/helpers";

/**
 * This is the content of the Describe your needs (DYN) popup
 * @param {DYNContent.propTypes} props
 * @return {JSX.Element}
 * @constructor
 */
export function DYNContent(props) {
    const [open, setOpen] = useState(true);
    const [moreViewOpen, setMoreViewOpen] = useState(false);
    const [isValidForm, setIsValidForm] = useState(false);
    const [errorPopupOpen, setErrorPopupOpen] = useState(false);

    const [itemDescription, setItemDescription] = useState('');
    const [itemDescriptionDisabled, setItemDescriptionDisabled] = useState(false);

    const [showDefineSupplier, setShowDefineSupplier] = useState(false);

    const [ud] = useState(UserDefaults.getLabelValueObjectFromPGData(props.userDefaults));

    const [itemCode, setItemCode] = useState({label: '', value: ''});
    const [companyCode, setCompanyCode] = useState(checkLabelValueObject(ud.companyCode));
    const [purchaseOrg, setPurchaseOrg] = useState(checkLabelValueObject(ud.purchaseOrganization));
    const [plant, setPlant] = useState(checkLabelValueObject(ud.plant));
    const [deliveryAddress, setDeliveryAddress] = useState(ud.deliveryAddress);
    const [l3Category, setL3Category] = useState('');
    const [accountType, setAccountType] = useState(checkLabelValueObject(ud.accountType));
    const [wbs, setWBS] = useState(checkLabelValueObject(ud.wbsProject));
    const [costCenter, setCostCenter] = useState(checkLabelValueObject(ud.costCenter));
    const [profitCenter, setProfitCenter] = useState(checkLabelValueObject(ud.profitCenter));
    const [glAccount, setGlAccount] = useState(checkLabelValueObject(ud.glAccount));
    const [taxCode, setTaxCode] = useState(checkLabelValueObject(ud.taxCode));
    const [supplierSelected, setSupplierSelected] = useState({});
    const [justificationValue, setJustificationValue] = useState([]);
    const [nonPSLCommentValue, setNonPSLCommentValue] = useState('');
    const [pslSuppliersTotal, setPslSuppliersTotal] = useState(0);
    const [materialType, setMaterialType] = useState('');
    const [materialTypeLoading, setMaterialTypeLoading] = useState(false);
    const [createPRLoading, setCreatePRLoading] = useState(false);
    const [itemCodeSearchProp, setItemCodeSearchProp] = useState('code');
    const [itemCodeError, setItemCodeError] = useState(false);
    const [itemDescriptionError, setItemDescriptionError] = useState(false);
    const [showL3SuggestionPopup, setShowL3SuggestionPopup] = useState(false);

    const vendorCode = (supplierSelected && supplierSelected.childSupplierCode) ? supplierSelected.childSupplierCode : '';

    useEffect(() => {
        const hasUserChanged =
            (vendorCode && vendorCode !== (ud.vendorCode?.value || '')) ||
            (costCenter?.value && costCenter.value !== (ud.costCenter?.value || '')) ||
            (glAccount?.value && glAccount.value !== (ud.glAccount?.value || ''));

        if (hasUserChanged && l3Category) {
            setShowL3SuggestionPopup(true);
        }
    }, [vendorCode, costCenter, glAccount, l3Category]);

    useEffect(() => {
        const isItemCodeEmpty = !itemCode?.value;
        const isItemDescriptionEmpty = !itemDescription?.trim();

        if (isItemCodeEmpty) {
            setItemCodeError(true);
            setItemDescriptionError(false);
        } else {
            if (isItemDescriptionEmpty) {
                setItemCodeError(false);
                setItemDescriptionError(true);
            } else {
                setItemCodeError(false);
                setItemDescriptionError(false);
            }
        }
    }, [itemCode, itemDescription]);

    const requester = (ud.requester === undefined || JSON.stringify(ud.requester) === '{}') ? {
        label: '',
        value: '',
        email: '',
    } : ud.requester;
    let spender = (ud.spender === undefined || JSON.stringify(ud.spender) === '{}') ? {
        label: '',
        value: '',
        email: '',
    } : ud.spender;

    if (isLabelValueEmpty(requester) && isLabelValueEmpty(spender)) {
        spender = props.name;
    }

    useEffect(() => {
        const emptyPRForDynPopup = createPRStore(
            new PurchaseRequest(
                null, null, new OneTimeVendor(), new NBSValidation(), new SBValidation(),
                null, null, null, new WaysOfBuying(), spender, requester, null, null, null,
                new HeaderDetails([], companyCode, purchaseOrg), new POSendingOptions(), new FinancialInfo(false, [], []),
                [], new AttachmentsInfo([]), null, null, null, null, null, null, null,
                null, null, null, null, null, null, null, null, null,
            ),
            props.context,
        );
        requestStores.set('new-pr', emptyPRForDynPopup);
    }, [companyCode, purchaseOrg]);

    const computeIsEmpty = () => {
        return {
            companyCode: !companyCode.label,
            purchaseOrganization: !purchaseOrg.label,
            plant: !plant.label,
        };
    };

    const [isEmpty, setIsEmpty] = useState(computeIsEmpty());

    const isJustificationValueValid = () => {
        if (pslSuppliersTotal > 0) {
            if (showDefineSupplier) {
                return justificationValue.length > 0;
            }
            return true;
        }
        return true;
    };
    const justificationValueValid = isJustificationValueValid();

    const isOTVCMVMTVCompleted = (supplierSelected) => {
        if (!supplierSelected) {
            return false;
        } else if (supplierSelected.supplierType === OneTimeVendor.supplierTypes.otv ||
        supplierSelected.supplierType === OneTimeVendor.supplierTypes.cmv ||
        supplierSelected.supplierType === OneTimeVendor.supplierTypes.mtv) {
            return supplierSelected.OTVName &&
                supplierSelected.OTVAddress.houseNumber &&
                supplierSelected.OTVAddress.street &&
                supplierSelected.OTVAddress.postalCode &&
                supplierSelected.OTVAddress.city &&
                supplierSelected.OTVAddress.state &&
                supplierSelected.OTVAddress.country &&
                (Array.isArray(supplierSelected.attachments) && supplierSelected.attachments.length > 0);
        } else {
            return true;
        }
    };

    const computeIsValidForm = () => {
        setIsValidForm(
            !!itemDescription &&
            !!itemCode &&
            !!companyCode.label &&
            !!purchaseOrg.label &&
            !!plant.label &&
            !!l3Category &&
            Object.keys(supplierSelected).length > 0 &&
            justificationValueValid &&
            isOTVCMVMTVCompleted(supplierSelected),
        );
    };

    useEffect(() => {
        computeIsValidForm();
    }, [
        itemDescription,
        itemCode,
        companyCode,
        purchaseOrg,
        plant,
        l3Category,
        supplierSelected,
        justificationValueValid,
    ]);

    // This useEffect clear the selected supplier if company code, purchase org or company code is modified
    useEffect(() => {
        setSupplierSelected({});
    }, [companyCode, purchaseOrg, itemCode]);

    const handleClose = (PRJson) => {
        if (PRJson) {
            props.setJSON(PRJson);
            props.context.trigger('Refresh');
        } else {
            props.setJSON(null);
        }
        setOpen(false);
        document.getElementById('popup017f2c5b2287c9930ec7').remove();
        props.forwardEvent();
    };

    const handleCloseErrorPopup = () => {
        setErrorPopupOpen(false);
    };

    const handleCreate = async () => {
        setCreatePRLoading(true);

        const createPR = async (baseUnit) => {
            const today = new Date().toDateString();
            const vendorCode = (supplierSelected && supplierSelected.childSupplierCode) ? supplierSelected.childSupplierCode : '99';

            let uniquePrId;
            let incotermResult;
            const uniquePrIdPromise = getUniquePrId(props.context);
            const incotermsPromise = await fetchAndProcessIncoterms({
                context: props.context,
                getIncoterms: props.getIncoterms,
                getAllIncoterms: props.getAllIncoterms,
                vendorCode: vendorCode,
                purchaseOrgValue: purchaseOrg.value,
            });

            const results = await Promise.allSettled([uniquePrIdPromise, incotermsPromise]);
            if (results[0].status === 'fulfilled') { // Unique ID
                uniquePrId = results[0].value;
            } else {
                setErrorPopupOpen(true);
            }

            if (results[1].status === 'fulfilled') { // Incoterms
                incotermResult = results[1].value;
            } else {
                incotermResult = {code: '', description: ''};
            }
            setCreatePRLoading(false);


            const {code: incotermCode, description: incotermDescription} = incotermResult;

            const comments = nonPSLCommentValue && nonPSLCommentValue.length > 0 ? 'Comments: '+ nonPSLCommentValue+'.' : '';
            const hasValidJustification = NON_PSL_JUSTIFICATIONS.some((justification) => justificationValue.includes(justification));
            const nonPslJustificationComment = justificationValue && justificationValue.length > 0 && hasValidJustification ? 'Non-PSL Justification: Reason: ' + justificationValue + '. ' + comments : '';
            const material = new Material(
                0,
                itemCode.label,
                itemDescription,
                '',
                baseUnit || '',
                baseUnit,
                supplierSelected?.unitPrice || '',
                ud.currency,
                supplierSelected?.pricePer || '1',
                taxCode ? taxCode : {label: '', value: ''},
                '',
                '',
                l3Category,
                addNBusinessDays(new Date(), supplierSelected?.supplierLeadTime || 5).toUTCString(),
                plant,
                ud.storageLocation,
                deliveryAddress,
                '',
                false,
                false,
                '',
                '',
                false,
                '',
                '',
                '',
                materialType,
                supplierSelected?.statusName || 'Blank',
                supplierSelected?.pslId,
                TRANSPORT_OPTIONS_ENUM['No transport cost added'],
                [],
                supplierSelected?.materialId,
                '',
                '0',
                convertSourceToLabelValue(supplierSelected?.pslId ? 'PSL' : 'NCT'),
            );
            const waysOfBuying = new WaysOfBuying(wayOfBuyingOptions[0], extractValuesFromWayOfBuyingOptions(wayOfBuyingOptions));
            const hidePriceValue = waysOfBuying.currentValue === 'FO' ? ud.hidePrice : false;
            const poSendingOptions = new POSendingOptions(
                true,
                true,
                false,
                '',
                false,
                [],
                false,
                false,
                false,
                hidePriceValue,
                '',
                false,
            );

            const nbsValidation = new NBSValidation([], '', [], '');
            const sbValidation = new SBValidation([], '', '');

            const account = new Account(
                {label: '', value: ''},
                glAccount ? glAccount : {label: '', value: ''},
                accountType ? accountType : {label: '', value: ''},
                wbs ? wbs : {label: '', value: ''},
                costCenter ? costCenter : {label: '', value: ''},
                profitCenter ? profitCenter : {label: '', value: ''},
                100,
                'percentage',
                '',
                '',
                false,
            );

            const financialInfo = new FinancialInfo(
                false,
                [],
                [account],
            );

            const attachmentsInfo = new AttachmentsInfo(
                supplierSelected.attachments?.map((ma) => new Attachment(ma.file, ma.topic, ma.user, new Date(ma.date).toDateString(), ma.name, ma.userId)) || [],
                [],
                '',
                '',
                false,
                '',
                complianceIndicatorOptions[0],
            );

            const oneTimeVendor = new OneTimeVendor(
                supplierSelected.OTVName,
                supplierSelected.OTVAddress,
                supplierSelected.OTVPhoneNumber,
                supplierSelected.supplierType,
            );

            const headerDetails = new HeaderDetails(
                [],
                companyCode,
                purchaseOrg,
                ud.purchasingGroup,
                {label: '', value: ''},
                [],
                plant,
                ud.storageLocation,
                deliveryAddress,
                addNBusinessDays(new Date(), supplierSelected?.supplierLeadTime || 5).toDateString(),
                '',
                '',
                {label: '', value: ''},
                {label: '', value: ''},
                {label: '', value: ''},
                {label: '', value: ''},
                {data: {label: incotermDescription, value: incotermCode}, manuallyModified: false},
                supplierSelected?.statusName,
                false,
                false,
                true,
            );

            const source = supplierSelected?.pslId ? SOURCES.PSL : SOURCES.DYN;

            const PRJson = createPRJson(new PurchaseRequest(
                (supplierSelected && supplierSelected.childSupplierName) ? supplierSelected.childSupplierName : 'Undefined',
                (supplierSelected && supplierSelected.childSupplierCode) ? supplierSelected.childSupplierCode : '99',
                oneTimeVendor,
                nbsValidation,
                sbValidation,
                today,
                '',
                '',
                waysOfBuying,
                spender,
                requester,
                '',
                `Please send the PDF of the PO to:\n---\nRequester: \nSpender: \nSupplier: \nOther: \n---\nProject/Order title: \n\n`,
                '',
                headerDetails,
                poSendingOptions,
                financialInfo,
                [material],
                attachmentsInfo,
                PurchaseRequest.statuses.created,
                [],
                supplierSelected?.supplierLeadTime || 0,
                true,
                source,
                '',
                '',
                '',
                '',
                '',
                uniquePrId,
                source,
                nonPslJustificationComment,
                null,
                getStringValueForSourceFromApiKey(source, source),
                convertSourceToLabelValue('NCT'),
            ));

            handleClose(PRJson);
        };

        await getBaseUnitLambda(
            props.context,
            props.getBaseUnit,
            itemCode.value,
            async (result) => {
                let baseUnit = '';
                const data = JSON.parse(result);
                if (data?.length > 0) {
                    baseUnit = data[0].meins;
                }
                await createPR(baseUnit);
                setCreatePRLoading(false);
            },
            async () => {
                await createPR('');
                setCreatePRLoading(false);
            },
        );
    };

    const handleItemDescriptionChange = (event) => {
        setItemDescription(event.target.value);
    };

    const handleItemCodeChange = (newValue) => {
        setItemCode(newValue);

        if (!newValue || !newValue.value) {
            setMaterialType('');
            setItemDescription('');
            setItemDescriptionDisabled(false);
            computeIsValidForm();
            setIsEmpty(computeIsEmpty());
            return;
        }

        const paddedValue = newValue.value.padStart(18, '0');

        // Fetch the L3 Category
        if (!isLabelValueEmpty(newValue)) {
            getL3CategoryLambda(
                props.context,
                props.getL3Category,
                paddedValue,
                (result) => {
                    try {
                        const parsedResult = JSON.parse(result);
                        if (parsedResult.length > 0) {
                            const newL3 = parsedResult[0].matkl + ' - ' + parsedResult[0].wgbez;
                            setL3Category(newL3);
                        } else {
                            if (!l3Category) {
                                setL3Category('');
                                setItemCode({label: '', value: ''});
                                setItemDescription('');
                                setMaterialType('');
                            }
                        }
                    } catch (error) {
                        console.error('Error parsing L3 Category result:', error);
                        if (!l3Category) {
                            setL3Category('');
                        }
                    }
                },
                () => {
                    if (!l3Category) {
                        setL3Category('');
                    }
                },
            );
        } else {
            setL3Category('');
            setItemCode({label: '', value: ''});
            setItemDescription('');
            setMaterialType('');
        }

        // Fetch the Material Type
        setMaterialTypeLoading(true);
        const [controlFlow, materialNumber] = props.getMaterialType.getInputs();
        const [Success, result, Error] = props.getMaterialType.getOutputs();

        const getMaterialTypeRunner = props.context.runner(props.getMaterialType)
            .set(materialNumber, newValue.value)
            .trigger(controlFlow);

        Promise.any([
            getMaterialTypeRunner.waitFor(Success),
            getMaterialTypeRunner.waitFor(Error),
        ])
            .then((outputFlow) => {
                if (outputFlow instanceof ErrorFlow) {
                    console.error('Material Type error:', outputFlow);
                } else {
                    try {
                        const parsedResult = JSON.parse(getMaterialTypeRunner.get(result));
                        if (parsedResult.length > 0) {
                            const materialType = parsedResult[0].mtart;
                            const isEditable = !['ERSA', 'UNBW', 'FERT', 'HALB', 'ZGNV', 'ZTAS'].includes(materialType);
                            setItemDescriptionDisabled(!isEditable);
                            setMaterialType(materialType);
                            if (!isEditable) {
                                const desc = newValue.label.split(' - ')[1];
                                setItemDescription(desc);
                            }
                        }
                    } catch (e) {
                        console.error('Error parsing Material Type result:', e);
                    }
                }
            })
            .finally(() => {
                setMaterialTypeLoading(false);
                getMaterialTypeRunner.destroy();
            });

        computeIsValidForm();
        setIsEmpty(computeIsEmpty());
    };

    const handleL3CategoryChange = (option) => {
        const newL3 = option?.value || '';
        if (l3Category && newL3 !== l3Category) {
            setItemCode({label: '', value: ''});
            setItemDescription('');
            setMaterialType('');
        }
        setL3Category(newL3);
    };

    const handleChangeItemCodeSearchProp = (newValue) => {
        setItemCodeSearchProp(newValue.target.value);
    };

    const handleCompanyCodeChange = (newValue) => {
        setCompanyCode(newValue);
        setPlant({label: '', value: ''});
        setDeliveryAddress({
            name: '',
            name2: '',
            street: '',
            houseNumber: '',
            postalCode: '',
            city: '',
            state: '',
            country: '',
        });
    };

    const handlePurchaseOrgChange = (newValue) => {
        setPurchaseOrg(newValue);
    };

    const handlePlantChange = (newValue) => {
        setPlant(newValue);

        let addressFromPlantResult = {};
        if (newValue.value) {
            getAddressFromPlantCodeLambda(props.context, props.getAddressFromPlant, newValue.value, newValue.addressNumber, '', props.name.value)
                .then((address) => {
                    try {
                        const parsedAddress = JSON.parse(address[0])[0];
                        addressFromPlantResult = {
                            name: parsedAddress.name1,
                            name2: parsedAddress.name2,
                            houseNumber: parsedAddress.house_num1,
                            street: parsedAddress.street,
                            postalCode: parsedAddress.post_code1,
                            city: parsedAddress.city1,
                            state: parsedAddress.county,
                            country: parsedAddress.nation,
                            manuallyModified: false,
                            addressNumber: parsedAddress.addrnumber,
                        };
                    } catch (e) {
                        console.warn('Error parsing address from plant result:', e);
                    }
                    setDeliveryAddress(addressFromPlantResult);
                });
        } else {
            setDeliveryAddress(addressFromPlantResult);
        }
    };

    const handleAccountTypeChange = (_, newValue) => {
        if (isLabelValue(newValue)) {
            setAccountType(newValue);
        }
    };

    const handleWBSChange = (newValue) => {
        setWBS(newValue);
    };

    const handleCostCenterChange = (newValue) => {
        setCostCenter(newValue);
    };

    const handleProfitCenterChange = (newValue) => {
        setProfitCenter(newValue);
    };

    const handleGlAccountChange = (newValue) => {
        setGlAccount(newValue);
    };

    const handleTaxCodeChange = (newValue) => {
        setTaxCode(newValue);
    };

    const handleSupplierSave = (isOneTimeVendorSelected, genericVendor, OTVInfo, isCollectiveMedicalVendorSelected, isMultiTimeVendorSelected, attachments) => {
        const selectedSupplier = {
            OTVAddress: {
                name: '',
                name2: OTVInfo.name2 ?? '',
                street: OTVInfo.street ?? '',
                state: OTVInfo.state ?? '',
                city: OTVInfo.city ?? '',
                houseNumber: OTVInfo.houseNumber ?? '',
                postalCode: OTVInfo.postalCode ?? '',
                country: OTVInfo.country ?? '',
            },
            OTVName: OTVInfo.name ?? '',
            OTVPhoneNumber: OTVInfo.phoneNumber ?? '',
            attachments: attachments ?? [],
        };

        const [OTVCode, CMVCode, MTVCode] = getVendorCodes(Config.getParameter('ENV'));

        if (isOneTimeVendorSelected) {
            selectedSupplier.childSupplierName = OTVInfo.name;
            selectedSupplier.childSupplierCode = OTVCode;
            selectedSupplier.supplierType = OneTimeVendor.supplierTypes.otv;
        } else if (isCollectiveMedicalVendorSelected) {
            selectedSupplier.childSupplierName = OTVInfo.name;
            selectedSupplier.childSupplierCode = CMVCode;
            selectedSupplier.supplierType = OneTimeVendor.supplierTypes.cmv;
        } else if (isMultiTimeVendorSelected) {
            selectedSupplier.childSupplierName = OTVInfo.name;
            selectedSupplier.childSupplierCode = MTVCode;
            selectedSupplier.supplierType = OneTimeVendor.supplierTypes.mtv;
        } else if (genericVendor) {
            const idxOfHyphen = genericVendor.indexOf(' - ');
            selectedSupplier.childSupplierName = genericVendor.substring(idxOfHyphen + 3);
            selectedSupplier.childSupplierCode = genericVendor.substring(0, idxOfHyphen);
            selectedSupplier.supplierType = OneTimeVendor.supplierTypes.generic;
        }

        setSupplierSelected(selectedSupplier);
    };

    const handleSupplierCancel = () => {
        setOpen(false);
        document.getElementById('popup017f2c5b2287c9930ec7').remove();
    };

    const handleSupplierClear = () => {
        setSupplierSelected({});
    };

    return (
        <ThemeProvider theme={EZPRTheme}>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                        return;
                    }
                    handleClose(null);
                }}
                fullWidth={true}
                maxWidth={'lg'}
            >
                <div className={'pr-popup-header'}>
                    <DialogTitle>What do you need?</DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={() => handleClose(null)}
                        sx={{
                            color: ezprOrange,
                        }}>
                        <CloseIcon
                            sx={{
                                width: '50px',
                                height: '50px',
                            }}
                        />
                    </IconButton>
                </div>
                <DialogContent className={'popup-dyn-container'}>
                    <div className={'popup-dyn-content'}>
                        <div>Company code: *</div>
                        <MasterDataDropdown
                            error={isEmpty.companyCode}
                            property={'Company Code'}
                            selectedValue={companyCode}
                            context={props.context}
                            getMasterData={props.getMasterData}
                            onChange={handleCompanyCodeChange}
                            filterQueryWithSearch={true}
                            userId={props.name.value}
                        />
                        <div>Purchase organization: *</div>
                        <MasterDataDropdown
                            error={isEmpty.purchaseOrganization}
                            property={'Purchase Organization'}
                            selectedValue={purchaseOrg}
                            context={props.context}
                            getMasterData={props.getMasterData}
                            onChange={handlePurchaseOrgChange}
                            filterQueryWithSearch={true}
                            userId={props.name.value}
                        />
                        <div>Plant: *</div>
                        <MasterDataDropdown
                            error={isEmpty.plant}
                            property={'Plant'}
                            selectedValue={plant}
                            context={props.context}
                            getMasterData={props.getMasterData}
                            onChange={handlePlantChange}
                            selectedCompanyCode={companyCode}
                            filterQueryWithSearch={true}
                            userId={props.name.value}
                        />
                        <div>L3 Category: *</div>
                        <L3CategoryDropdown
                            context={props.context}
                            selectedValue={l3Category ? {label: l3Category, value: l3Category} : null}
                            onChange={handleL3CategoryChange}
                            mlGetL3Category={props.mlGetL3Category}
                            companyCode={companyCode.value}
                            purchaseOrg={purchaseOrg.value}
                            plant={plant.value}
                            vendorCode={vendorCode}
                            costCenter={costCenter.value}
                            glAccount={glAccount.value}
                            getAllL3Categories={props.getAllL3Categories}
                        />
                        <div>Item code: *</div>
                        <div className={'popup-dyn-item-code'}>
                            <div className={'popup-dyn-item-code-text-field'}>
                                <ItemCodeDescriptionDropdown
                                    context={props.context}
                                    l3Category={l3Category}
                                    plant={plant}
                                    getItemCodeDesc={props.getItemCodeDesc}
                                    itemCodeSearchProp={itemCodeSearchProp}
                                    onChange={handleItemCodeChange}
                                    selectedValue={itemCode}
                                    error={itemCodeError}
                                    getMasterData={props.getMasterData}
                                    userId={props.name.value}
                                    enableSuggestions
                                />
                            </div>
                            <div className={'popup-dyn-item-code-select'}>
                                <FormControl size="small" fullWidth>
                                    <Select
                                        value={itemCodeSearchProp}
                                        onChange={handleChangeItemCodeSearchProp}
                                    >
                                        <MenuItem value={'code'}>By code</MenuItem>
                                        <MenuItem value={'name'}>By name</MenuItem>
                                    </Select>
                                </FormControl>
                            </div>
                        </div>
                        <div>Item Description: *</div>
                        <TextField
                            variant={'standard'}
                            size={'small'}
                            fullWidth
                            value={itemDescription}
                            onChange={handleItemDescriptionChange}
                            disabled={itemDescriptionDisabled}
                            error={itemDescriptionError}
                        />
                        <div>Material type:</div>
                        <TextField
                            value={materialType}
                            InputProps={{
                                startAdornment: (materialTypeLoading &&
                                    <InputAdornment position="start">
                                        <CircularProgress size={20}/>
                                    </InputAdornment>
                                ),
                            }}
                            variant={'standard'}
                            size={'small'}
                            disabled
                        />
                    </div>
                    <div style={{
                        display: 'flex',
                        gap: '5px',
                        alignItems: 'center',
                    }}>
                        <div onClick={() => setMoreViewOpen(!moreViewOpen)} className={'popup-dyn-more-info-text'}>
                            More information
                        </div>
                        <div onClick={() => setMoreViewOpen(!moreViewOpen)}
                            className={moreViewOpen ? 'popup-dyn-arrow-up' : 'popup-dyn-arrow-down'}
                        />
                    </div>
                    {moreViewOpen && <div className={'popup-dyn-horizontal-separator'}/>}
                    {moreViewOpen && (
                        <div className={'popup-dyn-more-info-content'}>
                            <div>Account type:</div>
                            <ControlledEZPRSelect
                                handleChange={handleAccountTypeChange}
                                options={accountTypeOptions}
                                value={accountType}
                            />
                            {
                                accountType.value === 'P' || accountType.value === 'S' ?
                                    <>
                                        <div>WBS Project</div>
                                        <MasterDataDropdown
                                            property={'WBS'} // with selectedAccountType being 'P' => WBS Project
                                            selectedValue={wbs}
                                            selectedCompanyCode={companyCode}
                                            onChange={handleWBSChange}
                                            context={props.context}
                                            getMasterData={props.getMasterData}
                                            filterQueryWithSearch={true}
                                            autoSelect
                                            userId={props.name.value}
                                        />
                                    </> : undefined
                            }
                            {
                                accountType.value === 'K' || accountType.value === 'S' ?
                                    <>
                                        <div>Cost Center</div>
                                        <MasterDataDropdown
                                            property={'Cost Center'} // with selectedAccountType being 'K' => Cost Center
                                            selectedValue={costCenter}
                                            onChange={handleCostCenterChange}
                                            context={props.context}
                                            getMasterData={props.getMasterData}
                                            selectedCompanyCode={companyCode}
                                            filterQueryWithSearch={true}
                                            userId={props.name.value}
                                        />
                                    </> : undefined
                            }
                            {
                                accountType.value === '2' ?
                                    <>
                                        <div>Profit Center</div>
                                        <MasterDataDropdown
                                            property={'Profit Center'}
                                            selectedValue={profitCenter}
                                            onChange={handleProfitCenterChange}
                                            context={props.context}
                                            getMasterData={props.getMasterData}
                                            selectedCompanyCode={companyCode}
                                            filterQueryWithSearch={true}
                                            userId={props.name.value}
                                        />
                                    </> : undefined
                            }
                            {
                                !!accountType.value ?
                                    <>
                                        <div>G/L number:</div>
                                        <MasterDataDropdown
                                            property={'GL Account'}
                                            selectedValue={glAccount}
                                            context={props.context}
                                            getMasterData={props.getMasterData}
                                            onChange={handleGlAccountChange}
                                            filterQueryWithSearch={true}
                                            userId={props.name.value}
                                        />
                                    </> : undefined
                            }
                            <div>Item tax code:</div>
                            <MasterDataDropdown
                                property={'Tax Code'}
                                selectedValue={taxCode}
                                onChange={handleTaxCodeChange}
                                context={props.context}
                                getMasterData={props.getMasterData}
                                filterQueryWithSearch={true}
                                userId={props.name.value}
                            />

                        </div>
                    )}

                    <div className={'popup-dyn-horizontal-separator'}/>
                    <SelectProviderSupplierTable
                        context={props.context}
                        itemCode={itemCode}
                        companyCode={companyCode}
                        getPSLRequest={props.getPSLRequest}
                        onSupplierSelected={setSupplierSelected}
                        setJustificationValue={setJustificationValue}
                        setNonPSLCommentValue={setNonPSLCommentValue}
                        onSelectNone={setShowDefineSupplier}
                        pslSuppliersTotal={pslSuppliersTotal}
                        setPslSuppliersTotal={setPslSuppliersTotal}
                    />
                    {showDefineSupplier &&
                        <div className={'popup-dyn-horizontal-separator'}/>}
                    {!companyCode.label || !purchaseOrg.label ?
                        <div>Please fill in the <b>Company Code</b> and <b>Purchase Organization</b> fields first.
                        </div> : showDefineSupplier && <>
                            <DefineSupplierContent
                                context={props.context}
                                onCancel={handleSupplierCancel}
                                onClose={handleSupplierSave}
                                onClear={handleSupplierClear}
                                prTag={'new-pr'}
                                prLocked={false}
                                inline={true}
                                DYNInfo={{
                                    plant: plant,
                                    deliveryAddress: deliveryAddress,
                                    l3Category: l3Category,
                                    materialCode: itemCode,
                                }}
                                onClosePunchOut={handleSupplierCancel}
                            />
                        </>}
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        sx={{
                            'color': '#fff',
                            'backgroundColor': ezprOrange,
                            '&:hover': {backgroundColor: '#F2ae49'},
                            ':disabled': {backgroundColor: 'rgba(0,0,0,0.26)'},
                        }}
                        variant={'outlined'}
                        onClick={handleCreate}
                        disabled={!isValidForm}
                        loading={createPRLoading}
                    >
                        <span>Add to cart</span>
                    </LoadingButton>
                </DialogActions>
            </Dialog>
            <ErrorPopup
                onClose={handleCloseErrorPopup}
                open={errorPopupOpen}
                title={'PR Creation Failed'}
                errorMessages={['An error occurred while attempting to create the Purchase Request.']}
            />
            <GenericPopup
                open={showL3SuggestionPopup}
                onClose={() => setShowL3SuggestionPopup(false)}
                disableBackdropClose={true}
                text={
                    <strong>
                        As you changed some criteria, other L3 categories may be more appropriate. Please check the L3 category suggestions.
                    </strong>
                }
                icon="info"
                color={ezprOrange}
                buttons={[
                    {
                        handleFunction: () => setShowL3SuggestionPopup(false),
                        text: 'OK',
                        color: ezprOrange,
                    },
                ]}
            />
        </ThemeProvider>
    );
}

DYNContent.propTypes = {
    forwardEvent: PropTypes.func,
    setJSON: PropTypes.func,
    name: PropTypes.object,
    userDefaults: PropTypes.object,
    context: PropTypes.instanceOf(BrickContext).isRequired,
    getPSLRequest: PropTypes.object,
    getMasterData: PropTypes.object,
    getL3Category: PropTypes.object,
    getMaterialType: PropTypes.object,
    getBaseUnit: PropTypes.object,
    getSupplier: PropTypes.object,
    getAddressFromPlant: PropTypes.object,
    getIncoterms: PropTypes.object,
    getAllIncoterms: PropTypes.object,
    mlGetL3Category: PropTypes.object,
    getAllL3Categories: PropTypes.object,
    getItemCodeDesc: PropTypes.object,
};
